import React, { useState, useEffect, useRef } from "react";

const Selectornew = ({ 
  options = [], 
  value, 
  onChange, 
  name = "",
  placeholder = "" 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // ✅ Search state
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm(""); // ✅ Reset search when closing
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (selectedValue) => {
    onChange(selectedValue, name);
    setIsOpen(false);
    setSearchTerm(""); // ✅ Reset search when selecting
  };

  // ✅ Filter options based on search input
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="relative w-full z-10" ref={dropdownRef}>
      <div
        className="relative border-b-2 border-gray-300 p-2 cursor-pointer flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{value ? options.find(opt => opt.value === value)?.label : placeholder}</span>
        <span className="text-gray-500">&#9662;</span> {/* Dropdown Arrow */}
      </div>

      {isOpen && (
        <div className="absolute left-0 w-full mt-2 bg-white border rounded shadow-lg max-h-60 overflow-auto z-10">
          
          {/* ✅ Search Input */}
          <div className="p-2 border-b">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-3 py-1 border rounded"
            />
          </div>

          {/* ✅ Show filtered options */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.value}
                className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </div>
            ))
          ) : (
            <div className="px-4 py-2 text-gray-500">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Selectornew;
